import { UUID } from '../../../types/shared/UUID';
import { BaseAPI } from '../../BaseApi';
import { eDepositorType } from '../../../types/order/emdAccess/eDepositorType';
import { eAPITags } from '../../eAPITags';
import { ISODateTimeString } from '../../../types/shared/ISODateTimeString';
import { IHasId } from '../../../types/shared/IHasId';
import { IHasEmail } from '../../../types/shared/IHasEmail';

interface EarnestMoneyDepositor extends IHasId, IHasEmail {}

export interface AccessCodeResponse extends IHasId {
  accesscode: string;
  orderId: UUID;
  depositor: EarnestMoneyDepositor;
  depositorType: eDepositorType;
  isActive: boolean;
  sentAt: ISODateTimeString | null;
  depositedAt: ISODateTimeString | null;
}

// the most recent element will be the **first** element of the sorted array.
export const sortBySentAt = (a: { sentAt: ISODateTimeString | null }, b: { sentAt: ISODateTimeString | null }) => {
  const aSentAt = a.sentAt ?? '';
  const bSentAt = b.sentAt ?? '';
  if (aSentAt < bSentAt) return 1;
  if (aSentAt > bSentAt) return -1;
  return 0;
};

export interface AccessCodeCreateRequest {
  orderId: UUID;
  depositorId: UUID;
  depositorType: eDepositorType;
}

export const EmdAccessCodeApi = BaseAPI.injectEndpoints({
  endpoints: (build) => ({
    listActiveOrderEmdAccessLinks: build.query<AccessCodeResponse[], UUID>({
      query: (orderId) => ({ url: `/timber/api/internal/orders/${orderId}/emd-access-codes` }),
      providesTags: (result, error, orderId) => [{ type: eAPITags.OrderEmdAccessCodes, id: orderId }],
    }),
    postAccessLink: build.mutation<AccessCodeResponse, AccessCodeCreateRequest>({
      query: (body) => ({ url: `/timber/api/internal/earnest-money-deposit/access-link`, method: 'POST', body }),
      invalidatesTags: (result, error, { orderId }) => [{ type: eAPITags.OrderEmdAccessCodes, id: orderId }],
    }),
  }),
  overrideExisting: false,
});

export const { useListActiveOrderEmdAccessLinksQuery, usePostAccessLinkMutation } = EmdAccessCodeApi;
